import React from "react";

const Commenti = ({
  id = "message",
  label = "Commenti",
  maxLength = 500,
  rows = 10,
  value,            // pass to make it controlled
  onChange,         // pass to make it controlled
  countGraphemes = false,
  readonly = true
}) => {
  const [internal, setInternal] = React.useState("");
  const val = value !== undefined ? value : internal;
  const counterId = `${id}-counter`;

  // Count function: align with browser (code units) or emoji-safe graphemes
  const count = React.useMemo(() => (s) => {
    if (countGraphemes && window.Intl && Intl.Segmenter) {
      const seg = new Intl.Segmenter(undefined, { granularity: "grapheme" });
      return [...seg.segment(s)].length;
    }
    return s.length;
  }, [countGraphemes]);

  const handleChange = (e) => {
    let v = e.target.value;

    // If counting graphemes, we also enforce the limit manually
    if (countGraphemes && window.Intl && Intl.Segmenter) {
      const seg = new Intl.Segmenter(undefined, { granularity: "grapheme" });
      const parts = [...seg.segment(v)].map(x => x.segment);
      if (parts.length > maxLength) v = parts.slice(0, maxLength).join("");
    }

    onChange ? onChange(v) : setInternal(v);
  };

  const remaining = Math.max(0, maxLength - count(val));

  return (
    <div style={{ display: "grid", gap: 0.5, marginLeft: "1em", marginTop: "1em" }}>
      <label htmlFor={id}>{label}</label>
      <textarea
        id={id}
        rows={rows}
        value={val}
        onChange={handleChange}
        // Use native enforcement unless we’re doing grapheme-aware counting
        maxLength={countGraphemes ? undefined : maxLength}
        aria-describedby={counterId}
        style={{ 
          resize: 'none',
          backgroundColor: readonly ? "#f6f7fb" : "white",
          color: readonly ? "#334155" : "inherit",
          borderColor: readonly ? "#cbd5e1" : "#94a3b8",
        }}
        readOnly={readonly}
      />
      <div id={counterId} aria-live="polite">
        {remaining} {remaining === 1 ? "carattere rimanente" : "caratteri rimanenti"}
      </div>
    </div>
  );
}

export default Commenti;
